import request from '@/utils/request'

// 当前店铺 ID（始终为 13）
export const SH_ID = 1
// 平台店铺 ID（积分规则的增删改必须使用平台 sh_id=1）
export const PLATFORM_SH_ID = 1

const BASE = '/jifen/jifen_main.php'

/**
 * 3.1 积分规则列表
 * @param {Object} params { sh_id, code, name, display, page, page_size }
 */
export const ruleLists = (params = {}) => {
  return request.post(`${BASE}?a=lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.2 新增积分规则（仅平台管理员，sh_id 强制为 1）
 * @param {Object} params { code, name, type, fixed_points, ratio_money, ratio_points, max_points, display, sort, remark }
 */
export const ruleAdd = (params = {}) => {
  return request.post(`${BASE}?a=add`, { sh_id: PLATFORM_SH_ID, ...params })
}

/**
 * 3.3 编辑积分规则（仅平台管理员，sh_id 强制为 1）
 * @param {Object} params { id, ...fields }
 */
export const ruleEdit = (params = {}) => {
  return request.post(`${BASE}?a=edit`, { sh_id: PLATFORM_SH_ID, ...params })
}

/**
 * 3.4 删除积分规则（仅平台管理员，sh_id 强制为 1）
 * @param {Object} params { id }
 */
export const ruleDel = (params = {}) => {
  return request.post(`${BASE}?a=del`, { sh_id: PLATFORM_SH_ID, ...params })
}

/**
 * 3.5 积分账户列表
 * @param {Object} params { keyword, min_balance, page, page_size }
 */
export const accountLists = (params = {}) => {
  return request.post(`${BASE}?a=account_lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.6 积分流水
 * @param {Object} params { sh_id(可选), crm_id, type, source, start_date, end_date, page, page_size }
 */
export const flowLists = (params = {}) => {
  return request.post(`${BASE}?a=flow_lists`, { sh_id: SH_ID, ...params })
}

/**
 * 3.7 人工增减积分
 * @param {Object} params { crm_id, points, remark }
 */
export const manualAdjust = (params = {}) => {
  return request.post(`${BASE}?a=manual_adjust`, { sh_id: SH_ID, ...params })
}

/**
 * 3.8 过期统计（已废弃，占位接口）
 * @param {Object} params
 */
export const expireReport = (params = {}) => {
  return request.post(`${BASE}?a=expire_report`, { sh_id: SH_ID, ...params })
}

/**
 * 3.9 积分兑换订单列表
 * @param {Object} params { status, keyword, start_date, end_date, page, page_size }
 */
export const exchangeOrders = (params = {}) => {
  return request.post(`${BASE}?a=exchange_orders`, { sh_id: SH_ID, ...params })
}

/**
 * 3.10 取消兑换单并退回积分
 * @param {Object} params { id }
 */
export const exchangeCancel = (params = {}) => {
  return request.post(`${BASE}?a=exchange_cancel`, { ...params })
}

/**
 * 3.11 推荐奖励发放记录
 * @param {Object} params { sh_id(可选), keyword, status, page, page_size }
 */
export const referralRecords = (params = {}) => {
  return request.post(`${BASE}?a=referral_records`, { sh_id: SH_ID, ...params })
}

/**
 * 3.12 某会员的下级列表
 * @param {Object} params { sh_id(可选), crm_id }
 */
export const referralTree = (params = {}) => {
  return request.post(`${BASE}?a=referral_tree`, { sh_id: SH_ID, ...params })
}
